import React, { Component } from 'react';
import {
  inject,
  observer,
} from 'mobx-react';
import {
  Field,
  Form,
  Formik,
} from 'formik';
import {
  Row,
  Col,
  ControlLabel,
  FormGroup,
  FormControl,
  Alert,
  Button,
  InputGroup,
} from 'react-bootstrap';
import LoadingButton from '../../components/LoadingButton/LoadingButton';
import {
  Portlet,
  PortletBody,
  PortletCaption,
  PortletTitle,
} from '../../components/Bootstrap/Portlet';
import { Dropdown } from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';

@inject('dischargeStore', 'mixStore')
@observer
class MixChargeForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: null,
    };
  }

  componentDidMount() {
    this.mounted = true;
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  initialValues = () => {
    return {
      mixItemId: null,
      dischargeSequenceId: null,
      rate: null,
    };
  };

  render() {
    const { dischargeStore, mixStore, t } = this.props;
    const { sequences, mixChargeId, mixCharge } = dischargeStore;
    const { mixOptions } = mixStore;

    const onCancel = () => {
      dischargeStore.selectMixCharge();
    };

    return (
      <Portlet>
        <PortletTitle>
          <PortletCaption>{mixChargeId > 0 ? t('Edit Mix Charge', {mixChargeId}) : t('New Mix Charge')}</PortletCaption>
        </PortletTitle>
        <PortletBody>
          <Formik
            enableReinitialize
            initialValues={
              mixChargeId > 0
                ? mixCharge.find(v => v.id === mixChargeId)
                : this.initialValues()
            }
            onSubmit={(values, actions) => {
              this.setState({
                error: null,
              });

              let promise;
              if (values.id > 0) {
                promise = dischargeStore.updateMixCharge(values);
              } else {
                promise = dischargeStore.addMixCharge(values);
              }

              promise.then(() => {
                if (!this.mounted) {
                  return;
                }

                actions.setSubmitting(false);
                dischargeStore.selectMixCharge();
              }).catch(e => {
                if (!this.mounted) {
                  return;
                }

                actions.setSubmitting(false);
                this.setState({
                  error: `${e.message}`,
                });
              });

            }
            }
          >{({ handleChange,
              values,
              setFieldValue,
              isSubmitting,
            }) => (
              <Form className={'mix-charge-form'}>
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <ControlLabel>{t('Mix')}</ControlLabel>
                      <Dropdown onChange={(e, data) => setFieldValue('mixItemId', data.value)}
                        value={values.mixItemId || ''}
                        fluid search selection options={mixOptions} />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <ControlLabel>{t('Sequence')}</ControlLabel>
                      <FormControl
                        name="dischargeSequenceId"
                        componentClass="select"
                        value={values.dischargeSequenceId || ''}
                        onChange={handleChange}
                        bsSize="sm"
                      >
                        <option value="" />
                        {sequences.map(option => (
                          <option key={option.id} value={option.id}>
                            {option.name ? `${option.name}` : `#${option.id}`}
                          </option>
                        ))}
                      </FormControl>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <ControlLabel>{t('Default Rate')}</ControlLabel>
                      <InputGroup>
                        <Field name="rate"
                          type="number"
                          value={values.rate || ''}
                          onChange={handleChange}
                          className="form-control input-sm" />
                        <InputGroup.Addon>{t('unit')} / {t('sec')}</InputGroup.Addon>
                      </InputGroup>
                    </FormGroup>
                  </Col>
                  <Col sm={12} className="text-right">
                    {!!this.state.error && <Alert bsStyle="danger">{this.state.error}</Alert>}
                    <Button onClick={onCancel}>{t('Cancel')}</Button>
                    {' '}
                    <LoadingButton
                      bsStyle="primary"
                      type="submit"
                      label={t('Save')}
                      loadingLabel={t('Saving')}
                      isLoading={isSubmitting}
                    />
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        </PortletBody>
      </Portlet>
    );
  }
}

export default withTranslation()(MixChargeForm);
